import { render, staticRenderFns } from "./laudoTecnico.vue?vue&type=template&id=4cfb60fc"
import script from "./laudoTecnico.vue?vue&type=script&lang=js"
export * from "./laudoTecnico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports